import cx from 'classnames';
// biome-ignore lint/correctness/noUnusedImports: existing error
import React, {FC, useCallback} from 'react';
import {useSelector} from 'react-redux';
import {getLoggedUserId} from '~/common/fabric/User/reducers/user';
import {useEventSave} from '~/OneStepCreateInvitation/hooks/useEventSave';
import {selectEventId} from '~/OneStepCreateInvitation/reducers/event/selector';
import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';
import {PlusIcon} from '~library/svg/PlusIcon';
import {TrashIcon} from '~library/svg/TrashIcon';
import {charcoal} from '~libSass/base/_exports.sass';
import './AddButtonWithTitle.sass';

interface AddButtonWithTitleProps {
  disabled?: boolean;
  title?: string;
  label?: string;
  onClick: () => void;
  dataQaId: string;
  className?: string;
  showRemoveIcon?: boolean;
}

export const AddButtonWithTitle: FC<AddButtonWithTitleProps> = ({
  disabled = false,
  title = '',
  label = 'default',
  onClick,
  dataQaId,
  className = '',
  showRemoveIcon = false,
}) => {
  const isLoggedIn: boolean = useSelector(getLoggedUserId);
  const eventId: string | undefined = useSelector(selectEventId);
  const {autoSave} = useEventSave();

  const onClickHandler = useCallback(async () => {
    if (!isLoggedIn) {
      autoSave();
    } else if (!eventId) {
      autoSave();
      onClick();
    } else {
      onClick();
    }
  }, [isLoggedIn, autoSave, onClick, eventId]);

  return (
    <div className="add-button-with-title-wrapper">
      <Button
        size="small"
        variant="transparent"
        onClick={onClickHandler}
        data-qa-id={dataQaId}
        className={cx(['add-button-with-title', className])}
        disabled={disabled}
        title={title}
        disableProcessing
      >
        {!showRemoveIcon && <PlusIcon ratio={0.5} color={charcoal} />}
        {showRemoveIcon && <TrashIcon color={charcoal} ratio={0.5} />}
        <Typography variant="list2">{label}</Typography>
      </Button>
    </div>
  );
};
